import "./bottom-banner.scss";

function BottomBanner() {
  return <div className="wrap-bottom">Channel Your Roots, Kurtas at 60% off.</div>;
}

export default BottomBanner;
